export const useHostName = (): string =>
  global?.window?.location?.hostname
    ? global.window.location.hostname === 'localhost'
      ? 'xing' // fallback just for local environments
      : global.window.location.hostname
    : ''; // ssr fallback
